import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = { class: "favorites-page" };
const _hoisted_2 = { class: "favorites-content" };
const _hoisted_3 = { class: "container" };
const _hoisted_4 = {
    key: 0,
    class: "loading-state"
};
const _hoisted_5 = {
    key: 1,
    class: "error-state"
};
const _hoisted_6 = {
    key: 2,
    class: "empty-state"
};
const _hoisted_7 = {
    key: 3,
    class: "favorites-grid"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = { class: "card-details" };
const _hoisted_10 = { class: "card-meta" };
const _hoisted_11 = {
    key: 0,
    class: "tag-chip"
};
const _hoisted_12 = { class: "popular-favorites-section" };
const _hoisted_13 = { class: "container" };
const _hoisted_14 = {
    key: 0,
    class: "loading-state"
};
const _hoisted_15 = {
    key: 1,
    class: "favorites-grid"
};
const _hoisted_16 = ["onClick"];
const _hoisted_17 = { class: "popular-badge" };
const _hoisted_18 = { class: "card-details" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = _resolveComponent("router-link");
    const _component_InterestCard = _resolveComponent("InterestCard");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[17] || (_cache[17] = _createStaticVNode("<section class=\"favorites-header\" data-v-7ea14ed9><div class=\"container\" data-v-7ea14ed9><div class=\"header-content\" data-v-7ea14ed9><h1 class=\"page-title\" data-v-7ea14ed9><i class=\"fas fa-heart me-2\" data-v-7ea14ed9></i> Mis Favoritos </h1><p class=\"page-subtitle\" data-v-7ea14ed9>Guarda y organiza tus lugares, artículos y eventos favoritos</p></div></div></section><section class=\"favorites-tabs\" data-v-7ea14ed9><div class=\"container\" data-v-7ea14ed9><div class=\"tabs-wrapper\" data-v-7ea14ed9></div></div></section>", 2)),
        _createElementVNode("section", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[1] || (_cache[1] = [
                            _createElementVNode("div", { class: "spinner" }, null, -1),
                            _createElementVNode("p", null, "Cargando tus favoritos...", -1)
                        ]))]))
                    : (_ctx.error)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "error-icon" }, [
                                _createElementVNode("i", { class: "fas fa-exclamation-triangle" })
                            ], -1)),
                            _cache[4] || (_cache[4] = _createElementVNode("h3", null, "Error al cargar favoritos", -1)),
                            _createElementVNode("p", null, _toDisplayString(_ctx.error), 1),
                            _createElementVNode("button", {
                                onClick: _cache[0] || (_cache[0] =
                                    //@ts-ignore
                                    (...args) => (_ctx.loadUserFavorites && _ctx.loadUserFavorites(...args))),
                                class: "btn btn-primary"
                            }, [...(_cache[2] || (_cache[2] = [
                                    _createElementVNode("i", { class: "fas fa-redo me-2" }, null, -1),
                                    _createTextVNode(" Reintentar ", -1)
                                ]))])
                        ]))
                        : (_ctx.getActiveFavorites().length === 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                _cache[6] || (_cache[6] = _createElementVNode("div", { class: "empty-icon" }, [
                                    _createElementVNode("i", { class: "fas fa-heart" })
                                ], -1)),
                                _cache[7] || (_cache[7] = _createElementVNode("h3", null, "No tienes favoritos aún", -1)),
                                _cache[8] || (_cache[8] = _createElementVNode("p", null, "Comienza a explorar y guarda tus lugares, artículos y eventos favoritos haciendo clic en el ícono de corazón.", -1)),
                                _createVNode(_component_router_link, {
                                    to: "/",
                                    class: "btn btn-primary"
                                }, {
                                    default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                            _createElementVNode("i", { class: "fas fa-compass me-2" }, null, -1),
                                            _createTextVNode(" Explorar Bolivia ", -1)
                                        ]))]),
                                    _: 1
                                })
                            ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getActiveFavorites(), (item) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        key: item.id,
                                        class: "favorite-card"
                                    }, [
                                        _createElementVNode("button", {
                                            class: "action-btn remove-favorite-btn",
                                            onClick: ($event) => (_ctx.removeFavorite(item))
                                        }, [...(_cache[9] || (_cache[9] = [
                                                _createElementVNode("i", { class: "fas fa-times" }, null, -1)
                                            ]))], 8, _hoisted_8),
                                        _createVNode(_component_InterestCard, {
                                            class: "favorite-card-content",
                                            title: item.title,
                                            subtitle: item.location,
                                            description: item.description,
                                            badge: item.badge,
                                            cover: item.image,
                                            to: item.link
                                        }, null, 8, ["title", "subtitle", "description", "badge", "cover", "to"]),
                                        _createElementVNode("div", _hoisted_9, [
                                            _createElementVNode("div", _hoisted_10, [
                                                (item.category)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                                                        _cache[10] || (_cache[10] = _createElementVNode("i", { class: "fas fa-tag" }, null, -1)),
                                                        _createTextVNode(" " + _toDisplayString(item.category), 1)
                                                    ]))
                                                    : _createCommentVNode("", true)
                                            ]),
                                            _createVNode(_component_router_link, {
                                                to: item.link,
                                                class: "btn btn-outline-primary w-100"
                                            }, {
                                                default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                                        _createTextVNode(" Ver detalles ", -1),
                                                        _createElementVNode("i", { class: "fas fa-arrow-right ms-2" }, null, -1)
                                                    ]))]),
                                                _: 1
                                            }, 8, ["to"])
                                        ])
                                    ]));
                                }), 128))
                            ]))
            ])
        ]),
        _createElementVNode("section", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
                _cache[16] || (_cache[16] = _createElementVNode("div", { class: "section-header" }, [
                    _createElementVNode("h2", { class: "section-title" }, [
                        _createElementVNode("i", { class: "fas fa-fire me-2" }),
                        _createTextVNode(" Los Favoritos ")
                    ]),
                    _createElementVNode("p", { class: "section-subtitle" }, "Los lugares y experiencias más populares entre nuestros visitantes")
                ], -1)),
                (_ctx.loadingPopular)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [...(_cache[12] || (_cache[12] = [
                            _createElementVNode("div", { class: "spinner" }, null, -1),
                            _createElementVNode("p", null, "Cargando favoritos populares...", -1)
                        ]))]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.popularFavorites, (item) => {
                            return (_openBlock(), _createElementBlock("div", {
                                key: item.id,
                                class: "favorite-card popular-card"
                            }, [
                                _createElementVNode("button", {
                                    class: "action-btn add-favorite-btn",
                                    onClick: ($event) => (_ctx.addFavorite(item))
                                }, [...(_cache[13] || (_cache[13] = [
                                        _createElementVNode("i", { class: "fas fa-heart" }, null, -1)
                                    ]))], 8, _hoisted_16),
                                _createElementVNode("div", _hoisted_17, [
                                    _cache[14] || (_cache[14] = _createElementVNode("i", { class: "fas fa-fire" }, null, -1)),
                                    _createTextVNode(" " + _toDisplayString(item.favoritesCount) + " favoritos ", 1)
                                ]),
                                _createVNode(_component_InterestCard, {
                                    class: "favorite-card-content",
                                    title: item.title,
                                    subtitle: item.location,
                                    description: item.description,
                                    badge: item.badge,
                                    cover: item.image,
                                    to: item.link
                                }, null, 8, ["title", "subtitle", "description", "badge", "cover", "to"]),
                                _createElementVNode("div", _hoisted_18, [
                                    _createVNode(_component_router_link, {
                                        to: item.link,
                                        class: "btn btn-outline-primary w-100"
                                    }, {
                                        default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                                                _createTextVNode(" Ver detalles ", -1),
                                                _createElementVNode("i", { class: "fas fa-arrow-right ms-2" }, null, -1)
                                            ]))]),
                                        _: 1
                                    }, 8, ["to"])
                                ])
                            ]));
                        }), 128))
                    ]))
            ])
        ])
    ]));
}
